// Italian date formatting helpers. Use these everywhere a date must be shown
// to end users. The Italian locale ("it-IT") renders dates as DD/MM/YYYY —
// what the salon owner expects.
//
// ⚠️ Never use these for HTML `<input type="date">` values or URL query params:
// those must remain ISO YYYY-MM-DD. Use them ONLY for user-visible text.

/** DD/MM/YYYY */
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

/** DD/MM/YYYY HH:MM */
export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("it-IT", {
        day: "2-digit", month: "2-digit", year: "numeric",
        hour: "2-digit", minute: "2-digit",
      })
    : "—";

/** Short: DD MMM (e.g. "26 ago") — for compact contexts. */
export const fmtDateShort = (iso) =>
  iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }) : "—";

/** DD/MM/YY HH:MM — very compact for dense lists. */
export const fmtDateTimeCompact = (iso) =>
  iso
    ? new Date(iso).toLocaleString("it-IT", {
        day: "2-digit", month: "2-digit", year: "2-digit",
        hour: "2-digit", minute: "2-digit",
      })
    : "—";
